export default __webpack_public_path__ + "static/media/icon-eye.d64239d4.svg";